import {Component} from '@angular/core';
import {ReferencesService} from '../references.services';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from "@angular/material/dialog";
import {AddEditGoldenRuleDialogComponent} from "./add-edit-golden-rule-dialog/add-edit-golden-rule-dialog.component";

@Component({
  selector: 'app-golden-rules-dialog',
  templateUrl: './golden-rules.component.html',
  styleUrls: ['./golden-rules.component.scss']
})

export class GoldenRulesComponent {

  isOnEditMode = false;
  goldenRulesList: Array<any> = [];
  newGoldenRule = '';

  constructor(private toaster: ToastrService, private matDialog: MatDialog, public referencesService: ReferencesService) {
    this.getAllGoldenRules();
  }

  // Getting all rules
  getAllGoldenRules() {
    this.referencesService.getAllReferencesByType('goldenRule').subscribe((result: any) => {
      this.goldenRulesList = result;
    }, error => {
      this.toaster.error('Unable to load the rules list.');
    });
  }

  openEditDialog(rule? : any) {
    this.matDialog.open(AddEditGoldenRuleDialogComponent, {
      panelClass: 'edit-rule-mat-dialog-container',
      data: rule ? JSON.parse(JSON.stringify(rule)) : null
    }).afterClosed().subscribe((res) => {
      if(res){
        this.getAllGoldenRules();
      }
    })
  }

  deleteRule(ruleId) {
    this.referencesService.deleteReferenceById(ruleId).subscribe(result => {
      this.toaster.success('Rule deleted successfully');
      this.getAllGoldenRules();
    }, error => {
      this.toaster.error('Unable to delete the rule, Please try again.');
    });
  }
}
